<script setup lang="ts" generic="T extends string">
import { ref } from "vue";
import BooleanBox from "./BooleanBox.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { BooleanBox }
});

const props = withDefaults(
  defineProps<{
    options: Array<T>;
    disabledIndexs?: Array<number>;
    initIndex?: number;

    isRounded?: boolean;

    colorBackground?: string;
    colorForeground?: string;
    colorDisabled?: string;

    colorChangeMode?: "reverse" | "only-foreground";

    fontSize?: string;
    boxWidth?: string;
    itemPadding?: string;
    labelPadding?: string;
  }>(),
  {
    initIndex: 0,

    isRounded: true,

    colorBackground: "#ffffff",
    colorForeground: "#5a82f0",
    colorDisabled: "#cccccc",

    colorChangeMode: "reverse",

    fontSize: "14px",
    boxWidth: "20px",
    itemPadding: "10px",
    labelPadding: "2px"
  }
);

const emits = defineEmits<{
  (event: "change", values: T): void;
}>();

const booleanBoxRefs = ref<any[]>([]);
const setRef = (el: any, index: number) => {
  if (el) {
    booleanBoxRefs.value[index] = el;
  }
};

let selectedIndex = ref(props.initIndex);

const change = (index: number, selected: boolean) => {
  if (selectedIndex.value !== index) {
    booleanBoxRefs.value[selectedIndex.value].toggleValue();
    if (selected) {
      selectedIndex.value = index;
      emits("change", props.options[selectedIndex.value]);
    }
  } else {
    if (!selected) {
      /// 强制选择
      booleanBoxRefs.value[selectedIndex.value].setValue(true);
    }
  }
};
</script>

<template>
  <div
    class="radio-group"
    v-for="(option, index) in options"
    :key="index"
    :style="['margin-left:' + (index > 0 ? props.itemPadding : 0)]"
  >
    <BooleanBox
      :ref="(el) => setRef(el, index)"
      :selected="selectedIndex == index"
      :disabled="
        disabledIndexs && disabledIndexs.findIndex((i) => i === index) >= 0
      "
      :isRounded="props.isRounded"
      :label="option"
      :labelPadding="props.labelPadding"
      :colorBackground="props.colorBackground"
      :colorForeground="props.colorForeground"
      :colorDisabled="props.colorDisabled"
      :colorChangeMode="props.colorChangeMode"
      :boxWidth="props.boxWidth"
      :fontSize="props.fontSize"
      @change="(v) => change(index, v)"
    ></BooleanBox>
  </div>
</template>

<style scoped>
.radio-group {
  position: relative;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
}
</style>
